import { render, staticRenderFns } from "./IndexBar.vue?vue&type=template&id=4de84035"
import script from "./IndexBar.vue?vue&type=script&lang=js"
export * from "./IndexBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports